import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode("导出")

import { defineComponent, ref, onMounted, reactive } from "vue";
import Datatable from "@/components/kt-datatable/Datatable3.vue";
import { MenuComponent } from "@/assets/ts/components";
import { setCurrentPageBreadcrumbs } from "@/core/helpers/breadcrumb";
import ApiService from "@/core/services/ApiService";
import { useStore } from "vuex";
import { useRoute, useRouter } from "vue-router";
// import Pie from "./components/Pie.vue";
// import Histogram from "./components/Histogram.vue";

interface Programme {
  id: number,
  name: string,
  site_id: number,
  site_name: string
}

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const store = useStore();
const route = useRoute();
const router = useRouter();
const dataT = ref<HTMLElement | null>(null);
const apiUrl= 'programme/view/' + route.params.id;
const tableHeader = ref<Array<any>>([]);
const defaultSort = ref('');
const filters = reactive({
  search: '',
  page_column: 'home'
})

const programme = ref<Programme>({
  id: 0,
  name: '',
  site_id: 0,
  site_name: ''
});

// const sdata = ref<any>(null);
// const sdata2 = ref<Array<any>>([]);

onMounted(() => {
  MenuComponent.reinitialization();
  ApiService.get('programme/' + route.params.id).then(({data}) => {
    programme.value = data
  })
  setCurrentPageBreadcrumbs("selection.view", ["selection.name", "selection.programme"]);
});

// 初始化表头再载入数据
const loadHeader = (func) => {
  ApiService.get('programme/fields/' + route.params.id).then(({data}) => {
    let th: Array<any> = []
    for (let d of data) {
      if (d.default != ''){
        let field = d.default[0] != '-' ? d.default : d.default.substr(1);
        (dataT as any).value.sortingField.value = {prop: field, order: d.default[0] != '-' ? "ascending" : "descending"};
      }
      let t = {
        name: d.dimension_name,
        key: d.dimension_field,
        sortable: d.sort,
        fixed: d.fixed,
      }
      th.push(t)
    }
    tableHeader.value = [...th]

    // ApiService.get('programme/view/' + route.params.id + '/chart').then(({data}) => {
    //   let th = {}
    //   for (let t of tableHeader.value) {
    //     th[t.key] = t.name
    //   }
    //   let tmp = {}
    //   for (let k in data.data1) {
    //     tmp[th[k]] = data.data1[k]
    //   }
    //   sdata.value = tmp

    //   let tmp2: Array<any> = []
    //   for (let d of data.data2) {
    //     let t = {}
    //     for (let k in d) {
    //       if (th[k]) t[th[k]] = d[k]
    //       else t[k] = d[k]
    //     }
    //     tmp2.push(t)
    //   }
    //   sdata2.value = [...tmp2]
    // })
    func();
  })
}

// 读取到数据后再变更表头
const tableHeaderAction = (fields) => {
  let th: Array<any> = []
  for(let v of tableHeader.value) {
    if(fields.indexOf(v.key) > -1) {
      th.push(v)
    }
  }
  tableHeader.value = [...th]
};
const toExcel = () => {
  let fields: Array<any> = [], field_names: Array<any> = [];
  for(let v of tableHeader.value) {
    fields.push(v.key);
    field_names.push(v.name);
  }
  (dataT as any).value.toExcel(fields, '选品方案' + programme.value.name + '的结果数据', field_names)
};

return (_ctx: any,_cache: any) => {
  const _component_el_page_header = _resolveComponent("el-page-header")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_image = _resolveComponent("el-image")!

  return (_openBlock(), _createBlock(Datatable, {
    ref_key: "dataT",
    ref: dataT,
    apiUrl: apiUrl,
    "table-header": tableHeader.value,
    "default-sort": defaultSort.value,
    data: {},
    rules: {},
    filters: _unref(filters),
    tableHeaderAction: tableHeaderAction,
    actionMenu: false,
    preLoad: loadHeader
  }, {
    search: _withCtx(() => [
      _createVNode(_component_el_page_header, {
        content: '选品方案' + programme.value.name + '共查询到' + ((dataT.value) ? dataT.value.pagination.total : 0) + '条商品',
        onBack: _cache[0] || (_cache[0] = ($event: any) => (_unref(router).push({name:'selection.programme'})))
      }, null, 8, ["content"]),
      _createVNode(_component_el_select, {
        modelValue: _unref(filters).search,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(filters).search) = $event)),
        placeholder: "方案名称关键词",
        size: "small",
        style: {"display":"none"}
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_option, {
            label: "价格分布",
            value: "price"
          }),
          _createVNode(_component_el_option, {
            label: "类目分布",
            value: "category"
          }),
          _createVNode(_component_el_option, {
            label: "销售分布",
            value: "sale"
          }),
          _createVNode(_component_el_option, {
            label: "折扣分布",
            value: "discount"
          }),
          _createVNode(_component_el_option, {
            label: "库存分布",
            value: "stock"
          }),
          _createVNode(_component_el_option, {
            label: "季节分布",
            value: "season"
          })
        ]),
        _: 1
      }, 8, ["modelValue"])
    ]),
    toolbar: _withCtx(() => [
      _createVNode(_component_el_button, {
        type: "primary",
        icon: "el-icon-document",
        size: "small",
        onClick: _cache[2] || (_cache[2] = ($event: any) => (toExcel()))
      }, {
        default: _withCtx(() => [
          _hoisted_1
        ]),
        _: 1
      })
    ]),
    "cell-goods_img": _withCtx(({ row: r }) => [
      _createVNode(_component_el_image, {
        style: {"width":"60px"},
        src: r.goods_img,
        "preview-src-list": [r.goods_img]
      }, null, 8, ["src", "preview-src-list"])
    ]),
    "cell-cat_names": _withCtx(({ row: r }) => [
      _createTextVNode(_toDisplayString(r.cat_names.join(", ")), 1)
    ]),
    _: 1
  }, 8, ["table-header", "default-sort", "filters"]))
}
}

})